import React from 'react';
import OptionLenghtWithUnit from 'components/show_drawing/redraw_form/options/OptionLenghtWithUnit.jsx';
import OptionIntegerWithRange from 'components/show_drawing/redraw_form/options/OptionIntegerWithRange.jsx';
import OptionBoolean from 'components/show_drawing/redraw_form/options/OptionBoolean.jsx';
import OptionAlignment from 'components/show_drawing/redraw_form/options/OptionAlignment.jsx';
import OptionFluteDirection from 'components/show_drawing/redraw_form/options/OptionFluteDirection.jsx';
import OptionSelect from 'components/show_drawing/redraw_form/options/OptionSelect.jsx';
import OptionWithChildren from 'components/show_drawing/redraw_form/options/OptionWithChildren.jsx';

// Boolean labels at or below this many characters render at half-width
// inside the .booleanGrid two-column grid. Longer labels (e.g. "separator
// thumb cut", "seperatör parmak kesiği") add .booleanGridItemWide on their
// own outer row and span the full row instead. The threshold is approximate
// — a character count, not a pixel measure — but the failure mode is
// graceful: an over-the-line label takes a whole row it would otherwise
// have shared. Exported so OptionBoolean and DimensionTextsIncludedChooser
// share the rule without duplicating the literal.
export const SHORT_BOOLEAN_LABEL_LIMIT = 16;

// Pure dispatcher: returns the leaf component for an option. Each leaf
// owns its own grid-column class on its outer row, so this dispatcher
// adds no wrapper itself — non-grid callers (ComboButtonsSection,
// OptionWithChildren) get bare leaves.
const renderOption = ({
  id,
  drawing,
  option,
  unit,
  optionsUserChanged,
  addToOptionsUserChanged,
  setRedrawRequested,
  labelGroup = 'dimensions',
  inputName,
  // OptionWithChildren renders its own parent option as a leaf without
  // losing the original option.children (needed so the leaf can still
  // render the Show/Hide button). Set this to skip the children-dispatch.
  renderAsLeaf = false
}) => {
  const key = `${id}${option.name}${unit}`;
  const shared = {
    id,
    drawing,
    option,
    unit,
    optionsUserChanged,
    addToOptionsUserChanged,
    setRedrawRequested,
    labelGroup,
    inputName
  };

  if (!renderAsLeaf && option.children && option.children.length > 0) {
    if (inputName != null) {
      throw new Error('[renderOption] inputName is not supported for options with children');
    }
    return <OptionWithChildren key={key} {...shared} />;
  }
  if (option.input_type === 'length' && option.possible_values.length === 0) {
    return <OptionLenghtWithUnit key={key} {...shared} />;
  }
  if (option.input_type === 'integer' && option.possible_values.length === 0) {
    return <OptionIntegerWithRange key={key} {...shared} />;
  }
  if (option.input_type === 'integer' && option.possible_values.length > 0) {
    throw new Error('[renderOption] OptionIntegerWithOptions is not implemented yet');
  }
  if (option.input_type === 'angle' && option.possible_values.length > 0) {
    return <OptionIntegerWithRange key={key} {...shared} />;
  }
  if (option.input_type === 'boolean') {
    return <OptionBoolean key={key} {...shared} />;
  }
  if (option.input_type === 'alignment') {
    return <OptionAlignment key={key} {...shared} />;
  }
  if (option.input_type === 'flute_direction') {
    return <OptionFluteDirection key={key} {...shared} />;
  }
  if (option.input_type === 'select') {
    return <OptionSelect key={key} {...shared} />;
  }

  throw new Error(`[renderOption] unsupported input_type: ${option.input_type}`);
};

export default renderOption;
